import {baseLocalConfig} from '../base/local.config';
import * as extendUtils from '../../../utils/object/extend.utils';
import {PrismConfigOptions} from '../environment-variables.interface';

export const cbsnewsLocalConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseLocalConfig, {
  environmentName: "Cbs News Local Environment",
  ionicEnvName: 'local',
  loginFormLogo: './assets/logos/cbsnews-logo.png',
  loginLogoClass: 'cbsnewsLogo',
  loginPageClass: 'cbsnewsLoginPageBackground',
  logoColor: 'black',
  enabledContentFeatures: {
    video: {
      upload: false,
      listing: false,
      create: false,
      edit: false,
    },
  },
  requiredFields: {
    content_article: {
      draft: ['slug', 'headline', 'editions'],
      publish: ['slug', 'headline', 'editions', 'body', 'dek', 'primaryAuthor', 'promoHed', 'primaryTopic', 'source', 'articlePage'],
      schedule: ['slug', 'headline', 'editions', 'body', 'dek', 'primaryAuthor', 'promoHed', 'primaryTopic', 'source', 'articlePage'],
      preview: ['slug', 'headline', 'editions', 'articlePage'],
    },
  },
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/cbsnews/local.config.ts